module.exports = __webpack_public_path__ + "img/icon_bell_fillin.3c704867.svg";